import { messages as ptmessages } from './pt';
import { messages as enmessages } from './en';
const messages = {
    ...ptmessages,
    ...enmessages
}
export { messages }